// src/components/UploadWorkspace/YTVideoDisplay.jsx
import React, { useState, useEffect } from 'react';
import VideoPreview from './VideoPreview';
import link_icon from '../../../../assets/images/icons/link-icon.png';
import './linkWorkspace.css';

const YTVideoDisplay = ({ workspaceVideoDetails = {}, doneVideos }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { videoId, thumbnailUrl } = workspaceVideoDetails;
  const done = videoId && doneVideos.includes(videoId);
  const ytUrl = 'https://youtu.be/' + videoId;

  useEffect(() => {
    if (videoId) {
      setIsLoading(false);
    }
  }, [videoId]);

  if (isLoading) {
    return (
      <section className="worklink-urlinput-section">
        <div className="link-skeleton link-skeleton-input" />
      </section>
    );
  }

  return (
    <>
      <section className="worklink-urlinput-section worklink-urlinput-section--done">
        <a
          href={ytUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="worklink-urlinput-container worklink-urlinput-link"
        >
          <div className="worklink-input-icon-wrapper">
            <img
              src={link_icon}
              alt="Link Icon"
              className="worklink-url-input-icon"
            />
            <span className="worklink-input-icon-wrapper-DONE">
              {ytUrl}
            </span>
          </div>
        </a>
      </section>

      {thumbnailUrl && (
        <VideoPreview
          details={workspaceVideoDetails}
          isProcessing={false}
          errorMessage={null}
          isTranscriptError={false}
          done={done}
        />
      )}
    </>
  );
};

export default YTVideoDisplay;
